<template>
  <div
    v-if="scheduledByList && Object.keys(scheduledByList).length"
    class="daily-total daily-total-by no_mobile"
  >
    <h2 class="title text--28 bold tx--blue no-marge">
      מקרא מקור שיבוץ:
    </h2>
    <ul>
      <li
        v-for="(scheduledBy, key) in scheduledByList"
        :key="key"
        class="flex flex--start"
      >
        <img :src="scheduledBy.image" :alt="scheduledBy.text" />
        <div>{{ scheduledBy.text }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ScheduledByList",
  props: {
    scheduledByList: {
      required: true
    }
  }
};
</script>
